import React, { Component } from 'react';

const PGAComponent = (importComponent, initializeFunc) => {
  return class extends Component {
    state = {
      component: null
    }

    async componentDidMount() {
      /* Running this init reducer doesn't make too much sense, but it was erroring if it didn't
      However, if it runs on every init it will rerun previous Redux actions (???)
      For that reason this global variable ensures it will get run at most once, when the PGA is initially loaded
      */
      //_Values all pga values are created here:
      //_Values _0
      //_Values FDA_FOO_
      //_Values
      //_Values
      //_Values
      let alreadyInitialized = window["GLOBALSTOPINIT"+(this.props.lineItemIndex+"_"+this.props.merchandiseId+"_"+this.props.formType+"_"+this.props.pgaGuid)];
      if (initializeFunc && !alreadyInitialized) await initializeFunc(`${this.props.merchandiseId}_#_${this.props.pgaGuid}`,this.props)//
      window["GLOBALSTOPINIT"+(this.props.lineItemIndex+"_"+this.props.merchandiseId+"_"+this.props.formType+"_"+this.props.pgaGuid)]=true;
      importComponent()
        .then(cmp => {
          return this.setState({ component: cmp.default });
        });
    }

    render() {
      const C = this.state.component;
      return C ? <C {...this.props} /> : null;
    }
  }
};

export default PGAComponent;